module.exports = __webpack_public_path__ + "images/devops_bundle_tile.2da9929b2c58f816e2cfe4c76ea98ddf.png";